import { render, staticRenderFns } from "./SaveChangesButton.vue?vue&type=template&id=4a5a598c&scoped=true"
import script from "./SaveChangesButton.vue?vue&type=script&lang=js"
export * from "./SaveChangesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a598c",
  null
  
)

export default component.exports